<template>
    <div class="star-rating" @mouseout="hoverIndex=0">
        <span v-for="index in starLimit" :key="index" class="star" :class="{'star-colored': hoverIndex >= index}" @mouseover="mouseOver(index)" @click="sendMark(index)"></span>
        <div class="star-rating__colored" :style="{width: ratingWidth}">
            <span v-for="index in starLimit" :key="index" class="star star-colored"></span>
        </div>
    </div>
</template>
<script>
export default {
    name: "StarRating",
    props: {
        rating: {
            type: Number,
            default: 0,
        },
        starLimit: {
            type: Number,
            default: 5,
        },
        editable: {
            type: Boolean,
            default: false
        },
        parentId: Number
    },
    computed:{
        ratingWidth(){
            return this.rating / this.starLimit * 100 + '%'
        }
    },
    data() {
        return {
            hoverIndex: 0
        };        
    },
    methods: {
        mouseOver(index) {
            if(this.editable) {
                this.hoverIndex = index;
            }
        },
        sendMark(index) {
            if(this.editable) { 
                this.hoverIndex = index;
                this.$emit('update', this.parentId, index);
            }            
        }
    }
}
</script>
<style scoped lang="scss">
.star-rating {
    position: relative;
    display: inline-flex;
    &__colored{
        display: inline-flex;
        position: absolute;
        width: 0;
        height: 100%;
        top: 0;
        left: 0;
        overflow: hidden;
    }
}
span{
    display: inline-block;
}
    .star{
        width: 24px;
        height: 24px;
        background-image: url(~@/assets/svg/star.svg);
        flex-shrink: 0;
        background-repeat: no-repeat;
    }
    .star-colored{
        width: 24px;
        height: 24px;
        background-image: url(~@/assets/svg/starC.svg);

        background-repeat: no-repeat;
    }
</style>